var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 6,
    fill: "#88D4FF",
    stroke: "#88D4FF",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_127348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_127348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 20.0002C18.5333 20.0002 17.2777 19.4779 16.2333 18.4335C15.1888 17.3891 14.6666 16.1335 14.6666 14.6668C14.6666 13.2002 15.1888 11.9446 16.2333 10.9002C17.2777 9.85572 18.5333 9.3335 19.9999 9.3335C21.4666 9.3335 22.7221 9.85572 23.7666 10.9002C24.811 11.9446 25.3333 13.2002 25.3333 14.6668C25.3333 16.1335 24.811 17.3891 23.7666 18.4335C22.7221 19.4779 21.4666 20.0002 19.9999 20.0002ZM9.33325 30.6668V26.9335C9.33325 26.1779 9.5277 25.4835 9.91659 24.8502C10.3055 24.2168 10.8221 23.7335 11.4666 23.4002C12.8444 22.7113 14.2444 22.1946 15.6666 21.8502C17.0888 21.5057 18.5333 21.3335 19.9999 21.3335C21.4666 21.3335 22.911 21.5057 24.3333 21.8502C25.7555 22.1946 27.1555 22.7113 28.5333 23.4002C29.1777 23.7335 29.6944 24.2168 30.0833 24.8502C30.4721 25.4835 30.6666 26.1779 30.6666 26.9335V30.6668H9.33325ZM11.9999 28.0002H27.9999V26.9335C27.9999 26.6891 27.9388 26.4668 27.8166 26.2668C27.6944 26.0668 27.5333 25.9113 27.3333 25.8002C26.1333 25.2002 24.9221 24.7502 23.6999 24.4502C22.4777 24.1502 21.2444 24.0002 19.9999 24.0002C18.7555 24.0002 17.5221 24.1502 16.2999 24.4502C15.0777 24.7502 13.8666 25.2002 12.6666 25.8002C12.4666 25.9113 12.3055 26.0668 12.1833 26.2668C12.061 26.4668 11.9999 26.6891 11.9999 26.9335V28.0002ZM19.9999 17.3335C20.7333 17.3335 21.361 17.0724 21.8833 16.5502C22.4055 16.0279 22.6666 15.4002 22.6666 14.6668C22.6666 13.9335 22.4055 13.3057 21.8833 12.7835C21.361 12.2613 20.7333 12.0002 19.9999 12.0002C19.2666 12.0002 18.6388 12.2613 18.1166 12.7835C17.5944 13.3057 17.3333 13.9335 17.3333 14.6668C17.3333 15.4002 17.5944 16.0279 18.1166 16.5502C18.6388 17.0724 19.2666 17.3335 19.9999 17.3335Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStudent);
export default __webpack_public_path__ + "static/media/ActiveStudent.565e045df576a750b5389768cea734fa.svg";
export { ForwardRef as ReactComponent };